import React from "react";
import moment from 'moment'
// import {useState} from "react";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";
import './index.scss'

export const VehicleTableRow = ({index, item, setShowFormDetails, setFormJobIobId, vehicleColumns, getFormDetails}) => {
  // const [showMore, setShowMore] = useState(false)
  const Jobs = useGetJobs();

  // const openMore = () => {
  //   setShowMore(!showMore)
  // }

  return (
    <div className="dashboard__vehicles-item-inner">
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[0].show ? 'hide' : ''}`}>
        <div className="dashboard__vehicles-item-avatar">
          <img
            src={item?.technician_profile_image ? item?.technician_profile_image : '/assets/images/avatar-placeholder.png'}
            alt="technician"/>
        </div>
        <span>{item?.technician_id ? item?.technician_id : 'Not assigned'}</span>
          <div className="vehicle__rating">
          <span>
            <img src="./assets/icons/star-rating.svg" alt="star" />
          </span>
            {item?.technician_rating}
          </div>
      </div>
      {/*<div className={`dashboard__vehicles-item-block ${!vehicleColumns[1].show ? 'hide' : ''}`}>*/}
      {/*  {item?.customer_name ? item?.customer_name : '--- --- ---'}*/}
      {/*</div>*/}
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[1].show ? 'hide' : ''}`}>
        {item?.job_address}, {item?.city}, {item?.state}, {item?.zip_code}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[2].show ? 'hide' : ''}`}>
        <div
          className={`dashboard__vehicles-item-status dashboard__vehicles-item-status_${item?.status}`}>{item?.status.replaceAll('_', ' ')}
        </div>
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[3].show ? 'hide' : ''}`}>
        {item?.job_datetime ? moment(item?.job_datetime).format("MMM DD YYYY") : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[4].show ? 'hide' : ''}`}>
        {item?.purchase_order ? item?.purchase_order : '--- --- ---'}
      </div>
      {/*<div className={`dashboard__vehicles-item-block ${!vehicleColumns[5].show ? 'hide' : ''}`}>*/}
      {/*  {item?.ticket_number ? item?.ticket_number : '--- --- ---'}*/}
      {/*</div>*/}
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[5].show ? 'hide' : ''}`}>
        {item?.verification_key ? item?.verification_key : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[6].show ? 'hide' : ''}`}>
        {item?.vin ? item?.vin : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[7].show ? 'hide' : ''}`}>
        {item?.vehicle_label ? item?.vehicle_label : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[8].show ? 'hide' : ''}`}>
        {item?.year ? item?.year : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[9].show ? 'hide' : ''}`}>
        {item?.make ? item?.make : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[10].show ? 'hide' : ''}`}>
        {item?.model ? item?.model : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[11].show ? 'hide' : ''}`}>
        {item?.odometer ? item?.odometer : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[12].show ? 'hide' : ''}`}>
        {item?.gps_serial ? item?.gps_serial : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[13].show ? 'hide' : ''}`}>
        {item?.camera_serial ? item?.camera_serial : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[14].show ? 'hide' : ''}`}>
        {item?.removed_serial ? item?.removed_serial : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[15].show ? 'hide' : ''}`}>
        {item?.time} hrs
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[16].show ? 'hide' : ''}`}>
        $ {item?.items_sum_price ? item?.items_sum_price.toString().replace(/(?=\B(?:\d{3})+(?!\d))/g, ',').replace('.', ',') : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[17].show ? 'hide' : ''}`}>
        {item?.installer_notes ? item?.installer_notes : '--- --- ---'}
      </div>
      <div className={`dashboard__vehicles-item-block ${!vehicleColumns[18].show ? 'hide' : ''}`}>
        {item?.payout_id ? item?.payout_id : '--- --- ---'}
      </div>
      <div onClick={() => {
        Jobs.getJobForm({jobId: item?.job_id, formId: item?.id});
        localStorage.setItem('jobId', item?.job_id)
        setFormJobIobId?.(item?.job_id)
        setShowFormDetails(true)
      }} className={`dashboard__vehicles-item-block ${!vehicleColumns[19].show ? 'hide' : ''}`}>
        <span><img src="/assets/icons/file.svg" alt="file"/></span>
        <span>View details</span>
      </div>
    </div>

  )
}
